import { getSiftSessionId } from '@/plugins/sift'

export default {
  namespaced: true,
  state: () => ({ deviceFingerprintId: null }),
  mutations: {
    SET_FP(state, id) { state.deviceFingerprintId = id || null },
  },
  actions: {
    async captureFingerprint({ commit }, { userId }) {
      const session_id = getSiftSessionId()
      if (!session_id) { commit('SET_FP', null); return null }

      const r = await fetch('/risk/sift/fingerprint', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ user_id: userId, session_id }),
      })

      if (!r.ok) { commit('SET_FP', null); return null }

      const data = await r.json()
      const id = data?.device_fingerprint_id ?? null
      commit('SET_FP', id)
      return id
    },
  },
}